import { memo } from 'react';

type SvgProps = React.ComponentPropsWithoutRef<'svg'>;

export const ItalicIcon = memo(({ className, ...props }: SvgProps) => {
    return (
        <svg
            width="24"
            height="24"
            className={className}
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M15.0222 3H19C19.5523 3 20 3.44772 20 4C20 4.55228 19.5523 5 19 5H15.693L10.443 19H14C14.5523 19 15 19.4477 15 20C15 20.5523 14.5523 21 14 21H9.02418C9.00802 21.0004 8.99181 21.0004 8.97557 21H5C4.44772 21 4 20.5523 4 20C4 19.4477 4.44772 19 5 19H8.30704L13.557 5H10C9.44772 5 9 4.55228 9 4C9 3.44772 9.44772 3 10 3H14.9782C14.9928 2.99968 15.0075 2.99967 15.0222 3Z"
                fill="currentColor"
            />
        </svg>
    );
});

ItalicIcon.displayName = 'ItalicIcon';
